@if (hasLoaded) {
<span>
    <span class="relative flex flex-col w-full h-full">
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button mat-icon-button [matTooltip]="'Útskrá'" (click)="lokaClick()">
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
        <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8" mat-dialog-content>
            <span>
                <div
                    class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600"
                >
                    <mat-icon class="text-current" svgIcon="heroicons_outline:shield-check"></mat-icon>
                </div>
            </span>
            <span>
                <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">
                    <!-- Title -->
                    <span>
                        <div class="text-xl leading-6 font-medium">{{firstAndMiddleName}}, vinsamlegast staðfestu auðkenni þitt</div>
                    </span>
                    <!-- Message -->
                    <span>
                        <div class="text-secondary mt-2"></div>
                    </span>
                    <span class="w-full">
                        <div
                            class="col-span-2 flex flex-col items-center justify-center py-8 px-1 rounded-2xl bg-indigo-50 text-indigo-800 dark:bg-white dark:bg-opacity-5 dark:text-indigo-400"
                        >
                            <div class="mt-1 text-sm sm:text-lg font-medium">Auðkenni þitt rennur út eftir</div>
                            <div class="text-5xl sm:text-7xl font-semibold leading-none tracking-tight">{{fancyTimeFormat(countdown)}}</div>
                        </div>
                    </span>
                    <!-- Divider -->
                    <div id="c-divider" class="w-full border-b"></div>
                    <span>
                        <!-- TODO, setja réttan hlekk -->
                        <div class="text-secondary text-small text-justify">
                            Innskráningarauðkenni þitt hefur ekki verið endurnýjað í {{fancyMinute(lastTokenSeconds)}}
                            {{fancyMinute(lastTokenSeconds) == 1 ? 'mínútu' : 'mínútur'}}. Vinsamlegast tilgreindu hvort þú viljir halda
                            virkri innskráningu.
                        </div>
                    </span>
                </div>
            </span>
        </div>
        <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
            <span>
                <button (click)="confirm()" mat-flat-button [color]="'primary'" [disabled]="false">
                    Halda virkri innskráningu @if (!hasLoaded) {
                    <mat-progress-spinner class="ml-10px" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                    }
                </button>
            </span>
        </div>
    </span>
</span>
}
